import * as a from '../../actions/action_types'

let defaultStateValue = {
  postLoadData: '', subLocationsList: [],
}

export default (state = defaultStateValue, action) => {
  switch (action.type) {
    case a.UPDATE_DATA:
      return { ...state, postLoadData: action.payload };
    case a.UPDATE_LOCATIONS_DATA:
      return { ...state, subLocationsList: action.payload };
    default:
      return state;
  }
};
